import Box from '@mui/material/Box';
import { useWatch } from 'react-hook-form';

import { CloverPaymentInformation } from 'payments/components/clover/CloverPaymentInformation';
import {
  type ChecklessPaymentDrawerProps,
  ChecklessPaymentsDrawer
} from 'reservations/checklessPayments/components/ChecklessPaymentsDrawer';

interface Props extends ChecklessPaymentDrawerProps {
  Button: (...props: any) => React.ReactElement;
  handleClick: () => void;
  handleSaveFailed?: () => void;
}

export const BaseCardModal = ({
  handleClick,
  Button,
  handleSaveFailed = () => {},
  ...props
}: Props) => {
  const date = useWatch({
    name: 'date'
  });

  return (
    <ChecklessPaymentsDrawer showFooter {...props}>
      <Box marginTop="24px">
        <CloverPaymentInformation bookingDate={date}>
          <Button
            handleClick={handleClick}
            handleSaveFailed={handleSaveFailed}
          />
        </CloverPaymentInformation>
      </Box>
    </ChecklessPaymentsDrawer>
  );
};
